import React, { useState, useEffect } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo.webp";
import Swal from "sweetalert2";
import {
  LuLayoutDashboard,
  LuBuilding2,
  LuUsers,
  LuTarget,
  LuBadgeDollarSign,
  LuSquareCheck,
} from "react-icons/lu";

import { useMsal } from "@azure/msal-react";
import { fetchMicrosoftPhoto } from "../../utils/msalPhoto";

import "../../assets/css/Sidebar/Sidebar.css";



  
const getInitials = (name = "") =>
  name
    .trim()
    .split(/\s+/)
    .map((n) => n.charAt(0))
    .join("")
    .toUpperCase()
    .slice(0, 2);

    
const Sidebar = ({ isOpen, onClose }) => {
  const { instance, accounts } = useMsal();
  const getLinkClass = ({ isActive }) =>
    isActive ? "sidebar-link active" : "sidebar-link";

  const [user, setUser] = useState(
    JSON.parse(sessionStorage.getItem("user") || "{}")
  );
  const [userPhoto, setUserPhoto] = useState(
    sessionStorage.getItem("user_photo") || null
  );

  useEffect(() => {
    const storedUser = JSON.parse(sessionStorage.getItem("user") || "{}");
    setUser(storedUser);
  }, []);

  const accountId = accounts?.[0]?.homeAccountId || accounts?.[0]?.username;

  useEffect(() => {
    const cachedPhoto = sessionStorage.getItem("user_photo");
    if (cachedPhoto) {
      setUserPhoto(cachedPhoto);
      return;
    }

    if (instance) {
      let isMounted = true;
      Promise.resolve(fetchMicrosoftPhoto(instance, accounts?.[0]))
        .then((photo) => {
          if (isMounted && photo) {
            setUserPhoto(photo);
            sessionStorage.setItem("user_photo", photo);
          }
        })
        .catch((err) => {
          console.debug("Silent Microsoft photo fetch error:", err);
        });

      return () => {
        isMounted = false;
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [instance, accountId]);

  const navigate = useNavigate();

  const handleLogout = async () => {
    const result = await Swal.fire({
      title: "Logout?",
      text: "Are you sure you want to logout?",
      icon: "warning",
      showCancelButton: true,
    });

    if (!result.isConfirmed) return;

    sessionStorage.clear();
    setUserPhoto(null);

    navigate("/login", { replace: true });
  };

  return (
    <>
      {isOpen && <div className="sidebar-overlay" onClick={onClose} />}
      <aside className={`sidebar ${isOpen ? "open" : ""}`}>
  <div className="sidebar-content">
    <div className="sidebar-brand">
      <img src={logo} alt="CRM Logo" className="sidebar-logo" />

      <div className="sidebar-brand-text">
        <h4>CRM Portal</h4>
      </div>
    </div>

    <div className="sidebar-divider" />


         <nav className="sidebar-nav">
      <NavLink
        to="/dashboard"
        className={getLinkClass}
        onClick={onClose}
      >
        <LuLayoutDashboard className="sidebar-icon" />
        <span>Dashboard</span>
      </NavLink>

      <NavLink
        to="/organizations"
        className={getLinkClass}
        onClick={onClose}
      >
        <LuBuilding2 className="sidebar-icon" />
        <span>Organizations</span>
      </NavLink>

      <NavLink
        to="/contacts"
        className={getLinkClass}
        onClick={onClose}
      >
        <LuUsers className="sidebar-icon" />
        <span>Contacts</span>
      </NavLink>

      <NavLink
        to="/leads"
        className={getLinkClass}
        onClick={onClose}
      >
        <LuTarget className="sidebar-icon" />
        <span>Leads</span>
      </NavLink>
      <NavLink
        to="/deals"
        className={getLinkClass}
        onClick={onClose}
      >
        <LuTarget className="sidebar-icon" />
        <span>Deals</span>
      </NavLink>


      {user?.role?.trim()?.toLowerCase()?.replace(/\s+/g, "_") !==
      "lead_generator" && (
      <NavLink
        to="/tasks"
        className={getLinkClass}
        onClick={onClose}
      >
        <LuSquareCheck className="sidebar-icon" />
        <span>
          {user?.role?.toLowerCase()?.includes("super")
            ? "All Tasks"
            : user?.role?.toLowerCase()?.includes("manager")
            ? "Team Tasks"
            : "My Tasks"}
        </span>
      </NavLink>
      )}
      
      <NavLink
        to="/expenses"
        className={getLinkClass}
        onClick={onClose}
      >
        <LuBadgeDollarSign className="sidebar-icon" />
        <span>Expenses</span>
      </NavLink>

      <NavLink
        to="/renewal"
        className={getLinkClass}
        onClick={onClose}
      >
        <LuBadgeDollarSign className="sidebar-icon" />
        <span>Renewal</span>
      </NavLink>
      <NavLink
        to="/users"
        className={getLinkClass}
        onClick={onClose}
      >
        <LuBadgeDollarSign className="sidebar-icon" />
        <span>Users</span>
      </NavLink>
    </nav>
  </div>
  

  {/* <div className="sidebar-footer">
    <div className="sidebar-user">
      <div className="user-avatar">
        {getInitials(user?.name)}
      </div>

      <div className="user-info">
        <div className="user-name">
          {user?.name || "Guest User"}
        </div>

        <div className="user-email">
          {user?.email || ""}
        </div>
      </div>
    </div>

    <button
      className="sidebar-link logout-btn"
      onClick={handleLogout}
    >
      <LuLogOut className="sidebar-icon" />
      <span>Logout</span>
    </button>
  </div> */}

  <div className="sidebar-footer">
    
  <div className="sidebar-user">
    

<div className="user-details">

    <div className="user-avatar" title={user?.name || "User profile"}>
      {userPhoto ? (
        <img
          src={userPhoto}
          alt={user?.name || "Profile"}
          className="user-avatar-img"
          onError={() => {
            setUserPhoto(null);
            sessionStorage.removeItem("user_photo");
          }}
        />
      ) : (
        getInitials(user?.name)
      )}
    </div>

    <div className="user-info">
      <div className="user-name">
        {user?.name || "Guest User"}
      </div>
      </div>
{/* 
      <div className="user-email">
        {user?.email || ""}
      </div> */}
    </div>
    <button
      className="logout-btn"
      onClick={handleLogout}
      title="Logout"
    >
      Logout
    </button>

  </div>
</div>
</aside>
    
    </>
  );
};

export default Sidebar;